import { z } from 'zod';

import { TranslationFnMap } from '~shared/i18n';

type LoginErrorsKey = 'USERNAME_REQUIRED' | 'PASSWORD_REQUIRED';

type LoginFormErrors = TranslationFnMap<LoginErrorsKey>;

const loginSchema = z.object({
  username: z.string().min(1, { error: 'USERNAME_REQUIRED' }),
  password: z.string().min(1, { error: 'PASSWORD_REQUIRED' }),
});

type LoginFormData = z.infer<typeof loginSchema>;

export { type LoginFormData, type LoginFormErrors, loginSchema };
